<template>
  <i
    aria-hidden="true"
    :class="iconClass"
    @click="$emit('click', $event)"
  />
</template>
<script>
import domainIcons from '@/domain/data/domain-icons.json';
import globalIcons from '@/data/global-icons.json';

export default {
  props: {
    /**
     * Nome da key do ícone em um dos arquivos enum de ícone
     */
    name: {
      type: String,
      required: true,
    },
  },
  computed: {
    iconClass() {
      const globalIcon = globalIcons[this.name];
      const domainIcon = domainIcons[this.name];

      if (process.env.NODE_ENV !== 'production') {
        if (globalIcon && domainIcon) {
          // eslint-disable-next-line no-console
          console.error(`Ícone '${this.name}' está duplicado.`);
        }
      }

      return globalIcon || domainIcon;
    },
  },
};
</script>
